var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYandex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 172,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m169.881 65.679-.667-3.316-28.199-4.926 16.386-22.169-1.905-2.084-24.102 11.558 3.048-30.695-2.477-1.42-14.671 24.82L100.814.5h-2.858l3.906 35.716-41.44-33.158L56.897 4.1 88.81 44.174 25.65 23.142l-2.858 3.221L79.189 58.48 1.357 64.92.5 69.753l80.88 8.81-67.448 55.8 2.858 3.884 80.308-43.673L81.19 171.5h4.859l30.77-72.379 18.767 56.653 3.335-2.558-7.717-57.6 29.246 33.158 1.906-3.032-22.388-41.116 31.247 11.558.286-3.505-28.008-20.653 26.389-6.347Z",
    fill: "#FED42B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYandex);
export default __webpack_public_path__ + "static/media/yandex.86602b537f58388f052a5b646d1f70da.svg";
export { ForwardRef as ReactComponent };